import axios from "axios";

const putDoctor = async (baseUrl, token, doctorId, doktor) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let putResponse = null

    await axios.put(baseUrl + `/doctor/` + doctorId, doktor, config)
        .then((res) => {
            putResponse = {
                status: res.status,
                result: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    result:  error.response.status
                }
            }
        });
    return putResponse
}

export default putDoctor;